<template>
  <div :class="classes">
    
    <div class="side-bg is-hidden-mobile"></div>

    <section class="hero is-dark is-fullheight column is-three-fifths">

      <a class="support-button" @click="$root.$emit('open-support-modal')">?</a>

      <div class="hero-body">
        <div class="container">
          <img class="zul-logo" :src="'./img/logo/' + logo.toLowerCase() + '.svg'" alt="">

          <h1 class="title">
            <small>{{$t('welcome.title')}}</small>
            <span>Zul Digital</span>
          </h1>
          <h2 class="subtitle">
            {{$t('welcome.subtitle', [cityName])}}
          </h2>
        </div>
      </div>

    </section>

    <section class="side is-dark column is-two-fifths">
        <div class="level-right language">
          <Language />
        </div>
        <router-view></router-view>
    </section>


    <support-modal></support-modal>
  </div>
</template>

<script>
import SupportModal from '../modals/Support.vue'
import Language from '../components/Language.vue'

export default {
  name: 'Home',
  props: {
    msg: String
  },
  mounted() {
    const querystringCity = this.$route.query.city;
    if (querystringCity) {
      this.$root.app.city = querystringCity;
    }
  },
  computed: {
    classes () {
      return {
        'home': true,
        'columns': true,
        'is-gapless': true,
        'is-bhz': this.$root.app.city === 'BHZ',
        'is-cwb': this.$root.app.city === 'CWB',
        'is-ftz': this.$root.app.city === 'FTZ',
        'is-ssa': this.$root.app.city === 'SSA',
        'is-jdn': this.$root.app.city === 'JDN',
        'is-cjz': this.$root.app.city === 'CJZ',
        'is-mon': this.$root.app.city === 'MON',
        'is-sgr': this.$root.app.city === 'SGR',
        // estapar
        'is-ame': this.$root.app.city === 'AME',
        'is-ara': this.$root.app.city === 'ARA',
        'is-ita': this.$root.app.city === 'ITA',
        'is-jac': this.$root.app.city === 'JAC',
        'is-jzf': this.$root.app.city === 'JZF',
        'is-lim': this.$root.app.city === 'LIM',
        'is-mog': this.$root.app.city === 'MOG',
        'is-mau': this.$root.app.city === 'MAU',
        'is-ric': this.$root.app.city === 'RIC',
        'is-sao': this.$root.app.city === 'SAO',
        'is-sbc': this.$root.app.city === 'SBC',
        'is-sbo': this.$root.app.city === 'SBO',
        'is-sca': this.$root.app.city === 'SCA',
        'is-sbv': this.$root.app.city === 'SBV',
        'is-sta': this.$root.app.city === 'STA',
        'is-tau': this.$root.app.city === 'TAU',
        'is-estapar': this.$root.app.isEstapar,
      }
    },
    city () {
      return this.$root.app.city;
    },
    logo() {
      return (this.$root.app.isEstapar) ? 'estapar' : this.$root.app.city;
    },
    cityName () {
      return this.$root.app.cityName;
    }
  },
  created () {
    // Redirect logged users to Dashboard
    if (this.$auth.check()) {
      this.$router.push('/dashboard')
    }
  },
  components: {
    SupportModal,
    Language
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../assets/sass/variables';

.language {
  position: absolute;
  top: 0;
  right: 0;
}

.home {
  height: 100vh;

  // fix columns margin
  &.columns.is-gapless:not(:last-child) { margin-bottom: 0; }

   // multicity colors
  @each $city, $map in $cities {
    &.is-#{$city} .hero {
      background-image: url('../../public/img/hero/' + map-get($map, 'background-image'));
    }

    &.is-#{$city} .side .form {
      border-left-color: map-get($map, 'primary');
    }

    &.is-#{$city} .support-button {
      background-color: map-get($map, 'primary');
    }
  }

  .support-button {
    position: absolute;
    bottom: 20px;
    right: 20px;
    border: 3px white solid;
    font-weight: bold;
    font-size: $size-3;
    border-radius: 100px;
    width: 55px;
    height: 55px;
  }

  //
  .hero {
    background-position: top center;
    background-size: cover;

    text-align: center;

    .container {
      max-width: 410px;
    }

    .title {
      font-size: $size-0;
      font-weight: bold;
      line-height: 1.25;

      small {
        font-size: $size-4;
        font-weight: normal;
        display: block;
      }
    }

    .subtitle {
      font-size: $size-4;
      padding-bottom: 1rem;
    }
  }

  .zul-logo {
    width: 124px;
    margin-bottom: 20px;
  }

  .side {
    position: relative;
    display: flex !important;
    flex-direction: column;
    justify-content: center;

    background-color: $grey-darker;

    .title,
    .subtitle,
    .subtitle a {
      color: $white;
    }

    .title {
      font-weight: bold;
      font-size: $size-3;
    }

    .subtitle {
      font-size: $size-6;

      a {
        text-decoration: underline;
      }
    }

    .header {
      padding: 3rem;
    }

    .form {
      background-color: $black;
      padding: 3rem 3rem 4rem;
      border: none;
      margin-bottom: 3rem;
      border-left: 2px transparent solid;
    }

    .buttons {
      display: flex;
      flex-direction: column;
      justify-content: center;

    }
  }

  .side-bg {
    position: absolute;
    top: 0; left: 50%;
    height: 100%; width: 100%;
    background-color: $grey-darker;
    z-index: -1;
  }
}
.home.is-estapar {
  .hero {
    .zul-logo {
      width: 324px;
      margin-bottom: 20px;
    }
    .title span {
      // display: none;
    }
  }
}
</style>
